import React from 'react';

function RowHandle() {
  return (
    <span
      className="inline-flex w-4 h-4 items-center justify-center text-ink-faint opacity-0 group-hover:opacity-100 focus-within:opacity-100 transition-opacity duration-150"
      aria-hidden
    >
      <svg width="10" height="16" viewBox="0 0 10 16" fill="currentColor">
        <circle cx="2.5" cy="3" r="1.15" />
        <circle cx="7.5" cy="3" r="1.15" />
        <circle cx="2.5" cy="8" r="1.15" />
        <circle cx="7.5" cy="8" r="1.15" />
        <circle cx="2.5" cy="13" r="1.15" />
        <circle cx="7.5" cy="13" r="1.15" />
      </svg>
    </span>
  );
}

export function DataTable({ trailing, columns, empty, children, bodyRef }) {
  return (
    <div className="flex-1 min-h-0 flex flex-col">
      {trailing ? (
        <div className="px-8 h-8 flex items-center justify-end gap-3 text-[12px] text-ink-muted">
          {trailing}
        </div>
      ) : null}
      <div ref={bodyRef} className="flex-1 min-h-0 overflow-auto">
        {empty ? (
          <div className="px-8 py-16 text-[14px] text-ink-faint">{empty}</div>
        ) : (
          <table className="w-full min-w-max text-[14px] leading-[1.35] text-left border-collapse">
            <thead className="sticky top-0 bg-white z-[1]">
              <tr className="border-b border-paper-line">
                <th className="w-8 pl-5 pr-0 py-1.5" aria-hidden />
                {columns.map((col) => (
                  <th
                    key={col.key}
                    className={`py-1.5 text-[12px] font-medium text-ink-muted whitespace-nowrap ${
                      col.align === 'right' ? 'text-right' : 'text-left'
                    } ${col.first ? 'pl-1 pr-2' : col.last ? 'pl-2 pr-8' : 'px-2'}`}
                    style={col.width ? { width: col.width } : undefined}
                  >
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>{children}</tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export function Td({ children, align, first, last, className = '' }) {
  return (
    <td
      className={`h-9 py-0 align-middle border-b border-paper-line ${
        align === 'right' ? 'text-right' : ''
      } ${first ? 'pl-1 pr-2' : last ? 'pl-2 pr-8' : 'px-2'} ${className}`}
    >
      {children}
    </td>
  );
}

export function TdAction({ children }) {
  return (
    <Td last align="right">
      <span className="inline-flex justify-end opacity-0 group-hover:opacity-100 focus-within:opacity-100 transition-opacity duration-150">
        {children}
      </span>
    </Td>
  );
}

export function Tr({ children, onClick, active, muted }) {
  return (
    <tr
      onClick={onClick}
      className={`group ${onClick ? 'cursor-pointer' : ''} ${
        active ? 'bg-accent-soft' : 'hover:bg-wash'
      } ${muted ? 'opacity-40' : ''}`}
    >
      <td className="w-8 pl-5 pr-0 h-9 align-middle border-b border-paper-line">
        <RowHandle />
      </td>
      {children}
    </tr>
  );
}

/** Notion-style group header: muted label + faint count. */
export function GroupTr({ colSpan, label, meta, count }) {
  return (
    <tr>
      <td
        colSpan={colSpan}
        className="pt-3.5 pb-1 pl-8 pr-8 border-b border-paper-line bg-white"
      >
        <div className="flex items-baseline gap-2 min-w-0">
          <span className="text-[12px] font-medium text-ink truncate">{label}</span>
          {meta ? (
            <span className="text-[12px] text-ink-faint truncate">{meta}</span>
          ) : null}
          {count != null ? (
            <span className="text-[12px] text-ink-faint tabular-nums">{count}</span>
          ) : null}
        </div>
      </td>
    </tr>
  );
}

export default DataTable;
